export default {
  namespaced: true,
  digital_signature: {
    title: "Digital Signature",
    file_video: "Video file",
    file_signature: "Signature file",
  },
};
